import fieldMixin from '@phoenix/mixins/fieldMixin';

export default {
  mixins: [fieldMixin],

  computed: {
    fieldClasses() {
      return [
        'input',
        this.fieldClass,
        {
          'input--error': this.isInvalid,
        },
      ];
    },

    placeholderOrLabel() {
      return this.field.placeholder ?? this.field.label;
    },
  },
};
